import React, { Component } from 'react';
import JSONEditorReact from './JsonEditor';

class JsonEditorContainer extends Component {
    constructor(props) {
        super(props);
        let initialText = props.json && props.json.trim() !== '' ? props.json : '{}';
        this.state = {
            text: initialText,
            mode: props.editMode ? 'code' : 'view'
        };
    }

    onModeChangeSelect = (event) => {
        this.setState({ mode: event.target.value });
    };

    onModeChange = (mode) => {
        this.setState({ mode });
    };

    onChangeText = (updatedText) => {
        this.setState({ text: updatedText });
        if (this.props.onChangeText) {
            this.props.onChangeText(updatedText);
        }
    };

    render() {
        const containerHeight = this.state.mode === 'view' || this.state.text === '{}' ? 'auto' : '800px';
        return (
            <div className="app" style={{ width: '100%', height: containerHeight }}>
                <div className="contents" style={{ height: '100%' }}>
                    <JSONEditorReact
                        text={this.state.text}
                        mode={this.props.editMode ? 'code' : 'view'}
                        indentation={4}
                        onChangeText={this.onChangeText}
                        onModeChange={this.onModeChange}
                    />
                </div>
            </div>
        );
    }
}

export default JsonEditorContainer;
